import React  from "react"
  import {
    Container,
    Col,
    Row} from 'reactstrap';

    import {isMobile} from 'react-device-detect';
    import Database from "./database/Database"
    import { Waypoint } from 'react-waypoint';

    class Part2 extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                mobile:isMobile,
                feedback1:false,
                feedback2:false,
                feedback3:false,
                figure1:"0",
                figure2:"0",
                figure3:"0",
                q1:0,
                q2:0,
                q3:0,
                text: ""
            }
            this.handleQuestion1 = this.handleQuestion1.bind(this);  
            this.handleQuestion2 = this.handleQuestion2.bind(this);  
            this.handleQuestion3 = this.handleQuestion3.bind(this);  


            this.handleQ1 = this.handleQ1.bind(this);  
            this.handleQ2 = this.handleQ2.bind(this);  
            this.handleQ3 = this.handleQ3.bind(this);  
          }

          handleQ1() {this.setState(prevState => {return {q1: 1}})}
          handleQ2() {this.setState(prevState => {return {q2: 1}})}
          handleQ3() {this.setState(prevState => {return {q3: 1}})}



            handleQuestion1(param){
              this.setState({
                  figure1: param,
                  feedback1: true
              });
              const scriptURL =
                `https://script.google.com/macros/s/AKfycby0kfnJ_QpsQFxjE5yUYoUvN1V--LIaCU5Yk4CjjnSMS7b6PyM/exec?overall=${0}&question1=${param}&question2=${0}&question3=${0}&question4=${0}&question0=${0}`;
              fetch(scriptURL)
                .then(response => console.log("Success!", response))
                .catch(error => console.error("Error!", error.message));
            }

            handleQuestion2(param){
            this.setState({
                figure2: param,
                feedback2: true
            });
            const scriptURL =
              `https://script.google.com/macros/s/AKfycby0kfnJ_QpsQFxjE5yUYoUvN1V--LIaCU5Yk4CjjnSMS7b6PyM/exec?overall=${0}&question1=${0}&question2=${param}&question3=${0}&question4=${0}&question0=${0}`;
            fetch(scriptURL)
              .then(response => console.log("Success!", response))
              .catch(error => console.error("Error!", error.message));
            }

            handleQuestion3(param){
            this.setState({
              figure3: param,
              feedback3: true
            });
            const scriptURL =
            `https://script.google.com/macros/s/AKfycby0kfnJ_QpsQFxjE5yUYoUvN1V--LIaCU5Yk4CjjnSMS7b6PyM/exec?overall=${0}&question1=${0}&question2=${0}&question3=${param}&question4=${0}&question0=${0}`;
            fetch(scriptURL)
            .then(response => console.log("Success!", response))
            .catch(error => console.error("Error!", error.message));
            }

        render()
        {
          let textselect= this.state.mobile?<p style={{opacity:this.state.feedback1?0:1}} className="aliagray text-center">TAP TO SELECT</p>:<p style={{opacity:this.state.feedback1?0:1}}className="aliagray text-center">CLICK TO SELECT</p>;
          let thankyou1=this.state.feedback1?<p className="text-center font-600 pad20 display-5">Thank you for your feedback</p>:<p className="text-center font-600 pad20 display-5">&nbsp;</p>
let feedquestion1 = this.state.feedback1?<Row className="abso">
<Col xs="6"><div className={`${this.state.figure1==="1" ? 'choiceselected' : ''}`}><p className="text-center font600 display-4">YES</p></div></Col>
<Col xs="6"><div className={`${this.state.figure1==="2" ? 'choiceselected' : ''}`}><p className="text-center font600 display-4">NO</p></div></Col>
</Row>:
<Row className="abso">
<Col xs="6"><div onClick={() => { this.handleQuestion1('1') }} className="choiceselect"><p className="text-center font600 display-4">YES</p></div></Col>
<Col xs="6"><div onClick={() => { this.handleQuestion1('2') }} className="choiceselect"><p className="text-center font600 display-4">NO</p></div></Col>
</Row>


let thankyou2=this.state.feedback2?<p className="text-center font-600 pad20 display-5">Thank you for your feedback</p>:<p className="text-center font-600 pad20 display-5">&nbsp;</p>
let feedquestion2 = this.state.feedback2?<Row className="abso">
<Col xs="6"><div className={`${this.state.figure2==="1" ? 'choiceselected' : ''}`}><p className="text-center font600 display-4">YES</p></div></Col>
<Col xs="6"><div className={`${this.state.figure2==="2" ? 'choiceselected' : ''}`}><p className="text-center font600 display-4">NO</p></div></Col>
</Row>:
<Row className="abso">
<Col xs="6"><div onClick={() => { this.handleQuestion2('1') }} className="choiceselect"><p className="text-center font600 display-4">YES</p></div></Col>
<Col xs="6"><div onClick={() => { this.handleQuestion2('2') }} className="choiceselect"><p className="text-center font600 display-4">NO</p></div></Col>
</Row>


let thankyou3=this.state.feedback3?<p className="text-center font-600 pad20 display-5">Thank you for your feedback</p>:<p className="text-center font-600 pad20 display-5">&nbsp;</p>
let feedquestion3 = this.state.feedback3?<Row className="abso">
<Col xs="6"><div className={`${this.state.figure3==="1" ? 'choiceselected' : ''}`}><p className="text-center font600 display-4">YES</p></div></Col>
<Col xs="6"><div className={`${this.state.figure3==="2" ? 'choiceselected' : ''}`}><p className="text-center font600 display-4">NO</p></div></Col>
</Row>:
<Row className="abso">
<Col xs="6"><div onClick={() => { this.handleQuestion3('1') }} className="choiceselect"><p className="text-center font600 display-4">YES</p></div></Col>
<Col xs="6"><div onClick={() => { this.handleQuestion3('2') }} className="choiceselect"><p className="text-center font600 display-4">NO</p></div></Col>
</Row>

let chart1=this.state.q1===1?<iframe src='https://ourworldindata.org/grapher/daily-cases-covid-19' frameBorder='0' scrolling='no' title="ourworld1" style={{width:"100%",height:"550px"}}></iframe>:<p></p>
let chart2=this.state.q2===1?<iframe src='https://ourworldindata.org/grapher/daily-deaths-covid-19' frameBorder='0' scrolling='no' title="ourworld2" style={{width:"100%",height:"550px"}}></iframe>:<p></p>
let chart3=this.state.q3===1?<iframe src='https://ourworldindata.org/grapher/full-list-cumulative-total-tests-per-thousand' frameBorder='0' scrolling='no' title="ourworld3" style={{width:"100%",height:"550px"}}></iframe>:<p></p>

            return (
                <div>
                <Container fluid><h2 className="text-center newsection"><span className="display-2 home-4">PART THREE</span></h2>
                </Container>
                    <Container id="chartmeanings" fluid>
                        <Container>
                            <Row className="justify-content-center align-items-center">
                                <Col lg="10" xs="12" className="text-left no-padding">
                                <Waypoint onEnter={()=> {this.handleQ1()}}/>  
                                <p className="display-2 aliagray home-2 text-center">
                                What do all the maps and charts mean?
                                </p>
                                <p>
                                The purpose of a map or chart is to take a lot of information and make it easily digestible. Different charts have different meanings. <span className="font600">No single chart can communicate everything about how COVID-19 behaves.</span> Even the choice of the x and y axis can give readers a very different understanding of the data.
                                </p>
                                <p>
                                Generally speaking, maps can tell you what is happening around the world right now, while charts tell you what has happened over time.
                                </p>
                                <p>
                                Below are a series of maps and charts from <a href="https://ourworldindata.org/coronavirus-data" target="_blank" rel="noopener noreferrer">OurWorldInData.org</a> - a comprehensive resource that aggregates data from various international sources. Use the built-in filters and tabs to select your country.
                                    </p>
                                    <br/>
                                    <div style={{backgroundColor:"rgba(238,217,150,0.2)", padding:"10px"}}>
                                    <Waypoint onEnter={()=> {this.handleQ2()}}/>  
                                    {chart1}
                                    <br/>
                                    <br/>
                                    <Row className="boxcard">
                                    <Col xl="6" xs="12" className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart answers:
                                    </p>
                                    <br/>
                                    <p><span className="font600">
                                    Q. How widespread is the virus?
                                    </span>
                                    </p>
                                    <p>
                                    A. Click on the map tab to see the number of new cases reported each day. Remember, this is lower than the actual number of people infected.
                                    </p>
                                    <p><span className="font600">Q. Which day had the most new cases?</span></p>
                                    <p>A. Technically it is the highest value on the y-axis but do not read too much into this. General trends matter more.</p>
                                    </section>
                                    </Col>
                                    <Col xl="6" xs="12" className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart does NOT answer:
                                    </p>
                                    <br/>
                                    <p>
                                    <span className="font600">
                                    Q. How many people were infected today?
                                    </span>
                                    </p>
                                    <p>
                                    A. This map only shows you the number of people who tested positive today. This excludes everyone else who may have been infected or may have symptoms but was not tested.
                                    </p>
                                    <p>
                                    <span className="font600">
                                    Q. Are countries with fewer reported cases doing well?
                                    </span>
                                    </p>
                                    <p>
                                    A. It depends. If these countries are not sufficiently testing or sharing their data, they may have many more undiagnosed cases. See the test rates chart below.
                                    </p>
                                    </section>
                                    </Col>
                                    </Row>
                                    <br/>
                                    </div>
                                  <div className="feedbackbox feedcase">
                                    <p className="text-center font-600 display-5">Does this chart improve your understanding of the global pandemic?</p>{textselect}
                                    </div>
                                    
                                    {feedquestion1}
                                    {thankyou1}
                                    <hr/>
                                    <div style={{backgroundColor:"rgba(185,211,211,0.2)", padding:"10px"}}>

                                    <Waypoint onEnter={()=> {this.handleQ3()}}/>  
                                    {chart2}
                                    <br/>
                                    <br/>
                                    <Row className="boxcard">
                                    <Col xl="6" xs="12" className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart answers:
                                    </p>
                                    <br/>
                                    <p>
                                    <span className="font600">
                                    Q. Are the number of deaths increasing or decreasing?
                                    </span>
                                    </p>
                                    <p>
                                    A. To answer this, you will need to look at the overall trends. If the slope is moving upwards, then deaths are increasing, if downwards then they are decreasing. Do not draw conclusions based on looking at daily changes on their own; these can differ based on how the data was collected the day before.
                                    </p>
                                    </section>
                                    </Col>
                                    <Col xl="6" xs="12" className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart does NOT answer:
                                    </p>
                                    <br/>
                                    <p><span className="font600">
                                    Q. How many total deaths have there been worldwide?
                                    </span>
                                    </p>
                                    <p>
                                    A. You would need to look at a cumulative chart to better answer this.
                                    </p>
                                    <p>
                                    <span className="font600">
                                    Q. Why do certain countries have more deaths?
                                    </span>
                                    </p>
                                    <p>
                                      A. Charts are not very good at answering the question "why".
                                      </p>
                                    </section>
                                    </Col>
                                    </Row>
                                    <br/>
                                    </div>
                                    <div className="feedbackbox feeddeath">
                                    <p className="text-center font-600 display-5">Does this chart improve your understanding of the global pandemic?</p>{textselect}
                                    </div>
                                    {feedquestion2}
                                    {thankyou2}
                                    <hr/>
                                    <div style={{backgroundColor:"rgba(144,120,127,0.2)", padding:"10px"}}>
                                    {chart3}
                                    <br/>
                                    <br/>
                                    <Row className="boxcard">
                                    <Col xl="6" xs="12" className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart answers:
                                    </p>
                                    <br/>
                                    <p>
                                    <span className="font600">
                                    Q. Which countries are testing the most?
                                    </span>
                                    </p>
                                    <p>
                                    A. Countries higher up on the list are testing more people relative to their populations. Normalising the data per 1,000 people is more meaningful than showing absolute numbers.
                                    </p>
                                    </section>
                                    </Col>
                                    <Col xl="6" xs="12" className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart does NOT answer:
                                    </p>
                                    <br/>
                                    <p>
                                    <span className="font600">
                                    Q. Are the number of tests increasing worldwide?
                                    </span>
                                    </p>
                                    <p>
                                    A. There is no standardised global measurement for testing. Test units vary significantly across countries, so be careful when comparing data.
                                    </p>
                                    </section>
                                    </Col>
                                    </Row>
                                    <br/>
                                    </div>
                                    <div className="feedbackbox feedtest">
                                    <p className="text-center font-600 display-5">Does this chart improve your understanding of the global pandemic?</p>{textselect}
                                    </div>
                                    {feedquestion3}
                                    {thankyou3}
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                </div>
            )
        }
    }
    export default Part2